import styled, { css } from "styled-components";

import Text from "@/components/Text";
import { FC } from "react";

const Badge = styled.div<{ $isSmall?: boolean }>`
  background: ${({ theme }) => theme.colors.lightGray};
  border-radius: 4px;
  height: 18px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $isSmall }) =>
    $isSmall &&
    css`
      height: 16px;
    `}
`;

interface Props {
  isSmall?: boolean;
  inactive?: boolean;
  type: 1 | 2;
}

const TestCompetitionBadge: FC<Props> = ({ isSmall, inactive, type }) => {
  return (
    <Badge $isSmall={isSmall}>
      <Text $color={inactive ? "gray" : "black"} $type="extraSmall">
        C{type}
      </Text>
    </Badge>
  );
};

export default TestCompetitionBadge;
